export default {
  bills: {
    title: '月次請求の概要',
    balance: '現在の残高：',
    rechargeNow: '今すぐチャージする',
    menu: '請求書管理',
    statement: '請求履歴',
    filter: {
      status: 'ステータス',
      all: 'すべて',
    },
    table: {
      paymentDays: '請求サイクル',
      date: '請求日',
      billAmount: '請求金額',
      paidAmount: '支払済み金額',
      arrearsAmount: '未払い金額',
      billDetail: '月次請求の詳細',
    },
    status: {
      settled: '解決済み',
      unresolved: '未解決',
      unsettled: '未請求',
      settledTips: '解決済み：請求書が発行済み 支払い済み',
      unresolvedTips: '未解決：請求書が発行済み  未払い',
      unsettledTips: '未請求：消費済み 未請求',
    },
  },
  billDetail: {
    table: {
      date: '日付',
      scene: 'シーン',
      materialTip:
        'クリエイティブ資料料の単価はパッケージによって制御され、変動する可能性があります。',
      '3dmodelTip':
        '3Dモデルの作業指示書の単価は変更される場合があります。詳細は3Dモデルの作業指示書リストをご覧ください。',
      making: {
        '3dmodel': '3Dモデル制作',
        material: 'クリエイティブ使用料',
      },
      objectID: 'ビジネスID',
      modelQuantity: 'モデルの数量',
      impression: 'インプレッション',
      billImpression: '請求可能なインプレッション',
      cpm: '請求可能なCPM',
    },
    options: {
      cap: 'ネットワーク別上限',
      allCap: '全ネットワーク上限',
      buyout: 'ネットワーク別買い取り',
      allBuyout: '全ネットワーク買い取り',
    },
  },
  statement: {
    search: {
      fingerprint: '素材の指紋を検索してください',
    },
    table: {
      advDisplayNum: '広告表示回数',
      advClickNum: '広告クリック数',
      advInstallNum: '広告インストール数',
      advExpenses: '広告費用',
      chargingNum: '請求可能な広告表示回数',
      materialCosts: '素材費用',
      firstTips: '素材費用が最大金額に達した場合，',
      secondTips: '後続の素材表示は請求の対象外となります。',
    },
  },
  usage: {
    title: '使用量明細',
    table: {
      date: '日付',
      usageType: 'タイプ',
      value: '控除額',
      unit: '単位',
    },
    bizType: {
      aiAsr: '音声認識',
      aiTts: '音声合成',
      aiDvs: 'スマートなシナリオ',
      aigcCredits: 'AI動画',
      voiceClone: '音声クローン',
      videos: '動画エクスポート',
      vrec: '画面録画ツール',
      download: 'ダウンロード',
      push: 'プッシュ',
      aiBanner: 'AI画像生成',
      videoOcr: '字幕認識',
      avatarVideo: 'アバターから動画',
      replaceMaterial: 'AI消去',
      analysisOnly: '参考動画解析',
      analysisReplace: '参考動画解析',
      scriptRetain: 'スクリプト書き換え',
      scriptReplace: '新規スクリプト生成',
      newAssetNewScript: '新規スクリプト→アセット',
      newAssetOldScript: '既存スクリプト＋商品情報からアセット生成',
      videoNewScript: '参考動画生成',
      videoOriginal: '動画から動画生成',
    },
  },
  materials: {
    table: {
      date: 'プッシュ日付',
      project: 'プロジェクト名およびID',
      fingerprint: 'クリエイティブのフィンガープリント',
      trafficType: 'プッシュチャネル',
      totalImpression: '合計インプレッション',
      totalBillImpression: '請求可能なインプレッション',
      totalServiceFee: '費用',
      projectName: 'プロジェクト名',
      billMethod: '課金方法',
      billMethodNum: '数量',
      billNum: '課金数量',
      price: '単価',
      status: '課金ステータス',
      totalAmount: 'クリエイティブの総費用',
      createdTime: '課金開始日',
      stopTime: '課金終了日',
      serviceFee: 'クリエイティブ消費費用',
      buyoutPrice: '買い取り価格',
      maxPrice: '価格上限',
      action: '操作',
      view: 'プレビュー',
      download: 'ダウンロード',
      buyout: '買い取り',
      cap: '先払い',
    },
    options: {
      charging: '課金中',
      endCharge: '課金終了',
    },
    capBuyoutDialog: {
      title: {
        cap: 'クリエイティブ費用の先払い',
        buyout: 'クリエイティブ買い取り支払い',
      },
      tip: {
        cap: '次のクリエイティブ費用の先払いを行いますか？支払いが成功すると、このクリエイティブに再度費用は発生しません。すべてのチャネルのクリエイティブ費用を先払いすると、このクリエイティブの他のチャネルでのダウンロード制限が自動的に解除されます。',
        buyout:
          '次のクリエイティブの買い取りを行いますか？買い取り後、このクリエイティブは買い取り日から使用料金は発生しません。すべてのチャネルで買い取りを行うと、このクリエイティブの他のチャネルのダウンロード制限が自動的に解除されます。',
      },
      creativeId: 'クリエイティブID：',
      creativeName: 'クリエイティブ名：',
      trafficType: 'プッシュチャネル：',
      price: '支払い待ち金額：',
      balance: '現在の残高：',
      disabledTip:
        '利用可能な残高が不足しています。再度購入する前にチャージしてください。',
      successful: '支払い完了',
      priceTip: {
        cap: '支払待ち金額は価格上限と既に支払われたクリエイティブ消費費用との差額です。',
        buyout:
          '同じクリエイティブの複数のチャネルで買い取られた費用の合計は、全チャネル買い取りの費用を超えません。',
      },
    },
    downloadDialog: {
      editProductInfo: '製品情報の変更',
      editProductInfoTip:
        '製品情報を変更した後、クリエイティブを再パッケージする必要があり、処理には時間がかかります。',
    },
  },
  balanceThresholdTips:
    '残高が不足しているため、機能は一時的に利用できません。リチャージ後、Playturboの利用を再開できます。',
  table: {
    bizType: 'シナリオ ',
  },
  cost: {
    return: 'ポイント返還',
    spend: 'ポイント使用',
  },
  status: {
    fail: '失敗',
  },
}
